export interface ICompetencyEditItem {
    id: string;
    competencyTypeId: string;
    number: number;
    name: string;
    description: string;
    activeState: number;
    rowId: string;

    isNew():boolean;
}

export class CompetencyEditItem implements ICompetencyEditItem {
    id: string;
    competencyTypeId: string;
    number: number;
    name: string;
    description: string;
    activeState: number;
    rowId: string;

    constructor();
    constructor(obj: ICompetencyEditItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.competencyTypeId = obj && obj.competencyTypeId || "";
        this.number = obj && obj.number || 0;
        this.name = obj && obj.name || "";
        this.description = obj && obj.description || "";
        this.activeState = obj && obj.activeState || 0;
        this.rowId = obj && obj.rowId || "";
    }

    isNew():boolean {
        return !this.rowId;
    }
}